import { FieldType } from '@wix/wix-data-schema-types'

export const PAGE_TYPES = {
  ITEM: 'item',
  COLLECTION: 'collection',
} as const

export type PageType = (typeof PAGE_TYPES)[keyof typeof PAGE_TYPES]

export const SUPPRTED_FIELD_TYPES_IN_URL = [FieldType.text, FieldType.number]

export const USER_PREFERENCES = {
  CREATE_DATA_BINDING_ROUTER_INTRO: {
    DONT_SHOW_AGAIN: 'createDataBindingRouter.firstTime.dontShowAgain',
  },
}

export const ERROR_TYPES = {
  COLLECTION_REMOVED: 'COLLECTION_REMOVED',
}
